import { StatusBar, Style } from '@capacitor/status-bar'
import { PlatformService } from './index'

export const StatusBarService = {
	async initialize() {
		if (!PlatformService.isNative()) return

		try {
			await StatusBar.setBackgroundColor({ color: '#e55352' })
			await StatusBar.setStyle({ style: Style.Light })
			await StatusBar.setOverlaysWebView({ overlay: false })
		} catch (e) {
			// StatusBar configuration failed silently
		}
	}
}
